module.exports = __webpack_public_path__ + "static/img/icon-img4.bb9618a.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/icon-img4.png
// module id = ZoPm
// module chunks = 1